import React from "react";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { endOfYear, getDayOfYear, startOfYear } from "date-fns";
import { useOcCalendar } from "oc/hooks";

interface MyTimesheetCalendarWeeklyHeaderProps {
  date: Date;
}

export const MyTimesheetCalendarWeeklyHeader = (
  props: MyTimesheetCalendarWeeklyHeaderProps,
) => {
  const theme = useTheme();

  const { date } = props;
  const dayName = moment(date).format("dddd");
  const day = moment(date).format("DD");

  let startDate = startOfYear(date);
  let endDate = endOfYear(date);

  const { data: Calendar } = useOcCalendar({ startDate, endDate });

  let dayCount = getDayOfYear(date);
  let dayState = Calendar?.charAt(dayCount - 1);

  return (
    <Box
      sx={{
        padding: "8px 0px",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          textTransform: "capitalize",
          color: dayState === "F" ? theme.palette.primary.main : {},
        }}
      >
        {dayName}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: dayState === "F" ? theme.palette.primary.main : {} }}
      >
        {day}
      </Typography>
    </Box>
  );
};

export default MyTimesheetCalendarWeeklyHeader;
